exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.Newpay .payType .vux-cell-bd {\n  align-self: flex-start;\n}", ""]);

// exports
